import React from "react";
import PropTypes from "prop-types";

const MarkdownIcon = ({className}) => (
  <svg
    data-testid="markdown-icon"
    viewBox="0 0 96 96"
    fill="#FFF"
    strokeMiterlimit="10"
    strokeWidth="2"
    className={className}
  >
    <path
      stroke="#979593"
      d="M67.1716,7H27c-1.1046,0-2,0.8954-2,2v78 c0,1.1046,0.8954,2,2,2h58c1.1046,0,2-0.8954,2-2V26.8284c0-0.5304-0.2107-1.0391-0.5858-1.4142L68.5858,7.5858 C68.2107,7.2107,67.702,7,67.1716,7z"
    />
    <path fill="none" stroke="#979593" d="M67,7v18c0,1.1046,0.8954,2,2,2h18" />
    <path
      fill="#C8C6C4"
      d="M79 61H48v-2h31c.5523 0 1 .4477 1 1l0 0C80 60.5523 79.5523 61 79 61zM79 55H48v-2h31c.5523 0 1 .4477 1 1l0 0C80 54.5523 79.5523 55 79 55zM79 49H48v-2h31c.5523 0 1 .4477 1 1l0 0C80 48.5523 79.5523 49 79 49zM79 43H48v-2h31c.5523 0 1 .4477 1 1l0 0C80 42.5523 79.5523 43 79 43zM79 67H48v-2h31c.5523 0 1 .4477 1 1l0 0C80 66.5523 79.5523 67 79 67z"
    />
    <path
      fill="#1A1A1A"
      d="M12,74h32c2.2091,0,4-1.7909,4-4V38c0-2.2091-1.7909-4-4-4H12c-2.2091,0-4,1.7909-4,4v32 C8,72.2091,9.7909,74,12,74z"
    />
    <text
      x="28"
      y="61"
      fill="#FFFFFF"
      fontSize="18"
      fontWeight="bold"
      fontFamily="Arial, sans-serif"
      textAnchor="middle"
    >
      MD
    </text>
  </svg>
);

MarkdownIcon.propTypes = {
  className: PropTypes.string,
};

export default MarkdownIcon;
